import { ComponentProps } from "react"
import { cn } from "@/utils/cn"
import { CircleAlert } from "lucide-react"

interface TextareaProps extends ComponentProps<"textarea"> {
  label: string
  error?: string | null | undefined
}

export function Textarea({
  label,
  className,
  error,
  required,
  ...props
}: TextareaProps) {
  return (
    <label
      className={cn(
        "block font-family-gtpressura text-md text-neutral-dark",
        className
      )}
    >
      <p>
        {label}
        {required && " *"}
      </p>
      <textarea
        required={required}
        className="mt-3 h-23 w-full resize-none rounded-xs border border-viola-200 bg-neutral-light p-4 outline-viola-200 transition-all duration-300"
        {...props}
      />
      {error && (
        <p className="mt-1 flex items-center gap-1 text-xs font-light text-alert">
          <CircleAlert size={16} />
          {error}
        </p>
      )}
    </label>
  )
}
